<template lang="html">
  <table class="table mb-0 table-striped">
    <thead class="bg-light">
      <tr>
        <th scope="col" class="border-0">ID</th>
        <th scope="col" class="border-0">Nome</th>
        <th scope="col" class="border-0 text-center">Opções</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in templates" :key="index" class="align-items-center">
        <td class="td-1">{{ row.id }}</td>
        <td class="td-5 link">
          <d-link :to="{ name: 'admin-quotation-template-edit', params: { templateId: row.id }}">{{ row.name }}</d-link>
        </td>
        <td class="td-2 text-center">
          <d-button size="sm" class="btn-danger" @click.prevent="confirmDeleteRow(row.id)">
            <i class="fas fa-trash d-xl-none d-xx-inline d-inline"></i><span class="d-none d-lg-none d-xl-inline"> Deletar</span>
          </d-button>
        </td>
      </tr>
      <tr v-if="templates.length === 0">
        <td colspan="9" class="no-content">Ainda não tem nenhum template.</td>
      </tr>
    </tbody>
    <confirmation-modal
      :cancel="close"
      :confirm="callback"
      title="Exclusão de template"
      message="Tem certeza que deseja excluir este template?"
    />
  </table>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import QuotationService from '_services/rest/modules/quotation';

export default {
  name: 'quotation-template-table',
  components: {
    ConfirmationModal,
  },
  props: {
    templates: {
      type: Array,
    },
  },
  data() {
    return {
      selectedQuotationId: null,
    };
  },
  methods: {
    ...mapActions([
      'setToggle',
      'checkIsCustomer',
    ]),
    close() {
      this.setToggle({ type: 'confirm_modal', bool: false });
    },
    callback() {
      this.setToggle({ type: 'progress', bool: true });
      QuotationService.deleteTemplate(this.selectedQuotationId)
        .then(() => {
          this.close();
          this.$router.push({ name: 'admin-quotation-template-list', params: { page: 1 } });
          Events.$emit('update:pagination', false);
          this.activeAlert({ message: 'Template deletado com sucesso', theme: 'success' });
        })
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
    confirmDeleteRow(id) {
      this.selectedQuotationId = id;
      this.setToggle({ type: 'confirm_modal', bool: true });
    },
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.link {
  color: $primary;
  a {
    cursor: pointer;
  }
}
.td {
  &-1 {
    width: 1%;
    min-width: 20px;
  }
  &-2 {
    width: 3%;
  }
  &-5 {
    width: 14%;
    min-width: 145px;
  }
}

</style>
